<template>
  <div class="section-total">
    <span class="sk-text-large-semibold section-total__label">
      {{ label }}
    </span>
    <span class="sk-text-large-semibold">
      {{ amount }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'SectionTotal',
  props: {
    label: {
      type: String,
      required: true,
    },
    amount: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss">
@use './shared' as *;

.section-total {
  display: flex;
  padding-inline: 16px;
  gap: 24px;
  justify-content: space-between;
}
</style>
